<template>
  <section class="ui-panel ui-panel--no-padding ui-expandable-panel">
    <button
      :class="{ 'ui-expandable-panel__toggle--closed': !expanded }"
      class="ui-expandable-panel__toggle"
      type="button"
      @click="emit('toggle')"
    >
      <slot name="title" />

      <div class="ui-expandable-panel__chevron-icon">
        <svg
          aria-hidden="true"
          focusable="false"
          height="11"
          version="1.1"
          viewBox="0 0 306 306"
          width="11"
          xml:space="preserve"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="matrix(-1.837e-16 1 -1 -1.837e-16 306 0)">
            <polygon
              points="94.35 0 58.65 35.7 175.95 153 58.65 270.3 94.35 306 247.35 153"
              fill="currentColor"
            />
          </g>
        </svg>
      </div>

      <div
        v-if="$slots.icon"
        class="ui-expandable-panel__icon"
      >
        <slot name="icon" />
      </div>
    </button>
    <div
      v-if="expanded"
      class="ui-expandable-panel__body"
    >
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
import { onBeforeMount, useSlots } from 'vue'

defineProps<{
  expanded: boolean
}>()

const slots = useSlots()

const emit = defineEmits<{
  toggle: []
}>()

onBeforeMount(() => {
  if (!slots.default) {
    throw Error('UiExpandablePanel: default slot cannot be empty')
  }
})
</script>

<style lang="scss">
@import '../../styles/abstracts.scss';

.ui-expandable-panel__toggle {
  align-items: center;
  background-color: transparent;
  border-top-left-radius: $sc-border-radius;
  border-top-right-radius: $sc-border-radius;
  border: 0;
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 20px;
  font-weight: 600;
  padding: 10px;
  text-align: left;
  width: 100%;

  @include breakpoint-min-width(medium) {
    padding: 20px;
  }

  &:hover {
    text-decoration: underline;

    .ui-expandable-panel__chevron-icon {
      transform: rotate(-90deg);
    }
  }

  &:focus {
    text-decoration: underline;
  }
}

.ui-expandable-panel__toggle--closed {
  border-radius: $sc-border-radius;
}

.ui-expandable-panel__chevron-icon {
  line-height: 1;
  margin-left: 15px;
  transition: transform 200ms;

  .ui-expandable-panel__toggle--closed & {
    transform: rotate(-90deg);
  }

  .ui-expandable-panel__toggle--closed:hover & {
    transform: rotate(0);
  }
}

.ui-expandable-panel__icon {
  line-height: 1;
  margin-left: auto;
  padding-left: 15px;
  text-align: right;
}

.ui-expandable-panel__body {
  padding: 5px 10px 10px;

  @include breakpoint-min-width(medium) {
    padding: 10px 20px 20px;
  }
}
</style>
